export default "__VITE_ASSET__DKX3xLQE__"